module.exports = __webpack_public_path__ + "img/day_logo(1).6563880.svg";